import { deepCompareAndDiff } from './deepCompareAndDiff';
import { includeOnlyIfDefined } from './includeOnlyIfDefined';

const pickByDefinedShape = <T extends object>(
	userData: Partial<T>,
	definedShape: Partial<T>
): Partial<T> => {
	const result: Partial<T> = {};

	for ( const key of Object.keys( definedShape ) as Array<keyof T> ) {
		const userValue = userData[ key ];
		const shapeValue = definedShape[ key ];

		if ( Array.isArray( userValue ) && Array.isArray( shapeValue ) ) {
			result[ key ] = userValue as T[typeof key];
		} else if (
			userValue &&
			shapeValue &&
			typeof userValue === 'object' &&
			typeof shapeValue === 'object'
		) {
			result[ key ] = pickByDefinedShape(
				userValue as Partial<typeof shapeValue>,
				shapeValue
			) as T[typeof key];
		} else {
			result[ key ] = userValue as T[typeof key];
		}
	}

	return result;
};

/* This helper is used on the 'create" pages to properly diff edits when there
is no DB data to compare too */
export const deepCompareAndDiffOnlyWhereDefined = <T extends object>(
	userData: Partial<T>,
	defaultData: T,
	transformBeforeCompare: Parameters<typeof deepCompareAndDiff>[2]
) => {
	// first we get the `defaultData` for non-falsy `userData`
	const partialDefaultData = includeOnlyIfDefined( userData, defaultData );
	// then we get the `userData` only where keys exist in `partialDefaultData`, recursively
	const dataToDiff = pickByDefinedShape( userData, partialDefaultData );
	return deepCompareAndDiff(
		dataToDiff,
		partialDefaultData,
		transformBeforeCompare
	);
};
